import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const impactoFrontal: TechniqueDefinition = {
  id: "impacto_frontal",
  name: "Impacto Frontal",
  description: "Strikes enemies in a short cone in front of the user.",
  family: "taijutsu",
  proficiency: "taijutsu",
  targeting: "frontal_cone",
  behavior: { kind: "damage" },
  levels: {
    1: {
      chakraCost: 16,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 10,
      attackCoefficient: 1.2,
      coneDegrees: 68,
    },
    2: {
      chakraCost: 16,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 11,
      attackCoefficient: 1.25,
      coneDegrees: 68,
    },
    3: {
      chakraCost: 17,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 12,
      attackCoefficient: 1.31,
      coneDegrees: 69,
    },
    4: {
      chakraCost: 17,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 13,
      attackCoefficient: 1.36,
      coneDegrees: 69,
    },
    5: {
      chakraCost: 18,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 14,
      attackCoefficient: 1.41,
      coneDegrees: 70,
    },
    6: {
      chakraCost: 18,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 15,
      attackCoefficient: 1.47,
      coneDegrees: 71,
    },
    7: {
      chakraCost: 19,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 16,
      attackCoefficient: 1.52,
      coneDegrees: 72,
    },
    8: {
      chakraCost: 20,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 17,
      attackCoefficient: 1.57,
      coneDegrees: 73,
    },
    9: {
      chakraCost: 21,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 18,
      attackCoefficient: 1.63,
      coneDegrees: 74,
    },
    10: {
      chakraCost: 22,
      cooldownMs: 6_000,
      range: 72,
      maxTargets: 3,
      power: 18,
      attackCoefficient: 1.68,
      coneDegrees: 75,
    },
  },
  visual: {
    effectId: 1464,
    cast: {
      placement: "caster_front",
      forwardOffsetPx: 32,
      rotateToFacing: true,
      scaleFrom: 0.25,
      scaleTo: 0.5,
      alpha: 1,
      fadeOutMs: 180,
      durationMs: 825,
    },
    impactEffectId: null,
  },
};
